export default {
    'delete_registration': 'Weet u zeker dat u deze actie uit wil voeren. Deze actie kan niet ongedaan gemaakt worden.',
    'logout': 'Weet u zeker dat u deze tablet wil afmelden? Alle niet gesynchroniseerde data zal verloren gaan.',
    'offline': 'Het lijkt erop dat er geen verbinding is met het internet.<br>Om dit apparaat te registeren dient u verbinding te kunnen maken met internet.',
};
